<template>
  <sidebar :title="selectedSubRetailer.subRetailerID != 0
    ? `Edit Dealer: ${selectedSubRetailer.name}`
    : 'Add Dealer'
    " :show="showSubRetailerSidebar" @on-close="close" size="sm">
    <template v-slot:body>
      <form @submit.prevent="submitSubRetailer" ref="subRetailerForm">
        <div class="">
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Type of Transaction</label>
                <div class="mb-3">
                  <select class="form-select" v-model="selectedSubRetailer.transactionType" required>
                    <option>SMART</option>
                    <option>BAYAD</option>
                    <option>BOTH</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Name</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.name"
                    :disabled="subRetailerSubmitting" required />
                </div>
              </div>
            </div>
          </div>
          <div class="row d-none" v-if="selectedSubRetailer.transactionType !== 'BAYAD'">
            <div class="col">
              <div class="form-group">
                <label>Corporate ID</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.corporateID"
                    :disabled="subRetailerSubmitting" />
                </div>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Email</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.email"
                    :disabled="subRetailerSubmitting" required />
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Password</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.subRetailerPassword"
                    :disabled="subRetailerSubmitting" required />
                </div>
              </div>
            </div>
          </div> -->

          <div class="row">
            <div class="col">
              <div class="form-group">
                <label>Branch</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.branch"
                    :disabled="subRetailerSubmitting" required />
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="selectedSubRetailer.transactionType !== 'BAYAD'">
            <div class="col">
              <div class="form-group">
                <label>Branch ID</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.branchID"
                    :disabled="subRetailerSubmitting" required />
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="selectedSubRetailer.transactionType !== 'SMART'">
            <div class="col">
              <div class="form-group">
                <label>Agent Rates %</label>
                <div class="mb-3">
                  <input type="number" step="0.01" min="0" max="100" class="form-control"
                    v-model.number="selectedSubRetailer.agentRate"
                    :disabled="subRetailerSubmitting"
                    :required="selectedSubRetailer.transactionType !== 'SMART'" />
                </div>
              </div>
            </div>
          </div>

           <div class="row" v-if="selectedSubRetailer.transactionType !== 'SMART'">
            <div class="col">
              <div class="form-group">
                <label>Dealer Rates %</label>
                <div class="mb-3">
                  <input type="number" step="0.01" min="0" max="100" class="form-control"
                    v-model.number="selectedSubRetailer.dealerRate"
                    :disabled="subRetailerSubmitting"
                    :required="selectedSubRetailer.transactionType !== 'SMART'" />
                </div>
              </div>
            </div>
          </div>

           <div class="row" v-if="selectedSubRetailer.transactionType !== 'SMART'">
            <div class="col">
              <div class="form-group">
                <label>Master Dealer Rates %</label>
                <div class="mb-3">
                  <input type="number" step="0.01" min="0" max="100" class="form-control"
                    v-model.number="selectedSubRetailer.sureloadRate"
                    :disabled="subRetailerSubmitting"
                    :required="selectedSubRetailer.transactionType !== 'SMART'" />
                </div>
              </div>
            </div>
          </div>

          <div class="row" v-if="selectedSubRetailer.transactionType !== 'SMART'">
            <div class="col">
              <div class="alert" :class="totalRateClass" role="alert">
                <strong>Total Rate: {{ totalRate }}%</strong>
                <span v-if="totalRate !== 100"> - Must equal 100%</span>
                <span v-else> ✓</span>
              </div>
            </div>
          </div>

          <div class="row" v-if="selectedSubRetailer.subRetailerID == 0">
            <div class="col">
              <div class="form-group fst-italic">
                <label>Note: Please save your temporary password. Thank you!</label>
              </div>
            </div>
          </div>

          <div class="row d-none" v-if="selectedSubRetailer.transactionType !== 'BAYAD'">
            <div class="col">
              <div class="form-group">
                <label>Username</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.userName"
                    :disabled="subRetailerSubmitting" />
                </div>
              </div>
            </div>
            <div class="col" v-if="selectedSubRetailer.transactionType !== 'BAYAD'">
              <div class="form-group">
                <label>Password</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.password"
                    :disabled="subRetailerSubmitting" />
                </div>
              </div>
            </div>
          </div>
          <div class="row d-none" v-if="selectedSubRetailer.transactionType !== 'BAYAD'">
            <div class="col">
              <div class="form-group">
                <label>Secret Key</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.secretKey"
                    :disabled="subRetailerSubmitting" />
                </div>
              </div>
            </div>
            <div class="col" v-if="selectedSubRetailer.transactionType !== 'BAYAD'">
              <div class="form-group">
                <label>Terminal ID</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.terminalID"
                    :disabled="subRetailerSubmitting" />
                </div>
              </div>
            </div>
          </div>
          <div class="row d-none">
            <div class="col-9">
              <div class="form-group">
                <label>Address</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.address"
                    :disabled="subRetailerSubmitting" />
                </div>
              </div>
            </div>
            <div class="col">
              <div class="form-group">
                <label>Zip Code</label>
                <div class="mb-3">
                  <input type="text" class="form-control" v-model="selectedSubRetailer.zipCode"
                    :disabled="subRetailerSubmitting" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="text-center">
          <button type="submit" class="btn bg-info bg-violet text-white w-100 mt-4 mb-0"
            :disabled="subRetailerSubmitting">
            <div class="spinner-border spinner-border-sm" role="status" v-if="subRetailerSubmitting">
              <span class="sr-only">Loading...</span>
            </div>
            Submit
          </button>
        </div>
      </form>

      <div v-if="selectedSubRetailer.subRetailerID != 0" class="mt-4">
        <button type="button" class="btn btn-outline-secondary w-100" @click="showPasswordForm = !showPasswordForm">
          {{ showPasswordForm ? 'Cancel Password Change' : 'Change Password' }}
        </button>
        <div v-if="showPasswordForm" class="mt-3">
          <input type="password" class="form-control mb-2" placeholder="New Password"
            v-model="passwordForm.newPassword" />
          <input type="password" class="form-control mb-2" placeholder="Confirm Password"
            v-model="passwordForm.confirmPassword" />
          <button class="btn btn-info w-100" @click="changePassword">Submit Password Change</button>
        </div>
      </div>

    </template>
  </sidebar>
  <GlobalModal :show="modal.show" :type="modal.type" :title="modal.title" :message="modal.message"
    @close="modal.show = false" />
</template>

<script>
import sidebar from "../../../../../components/sidebar.vue";
import GlobalModal from "@/components/GlobalModal.vue";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  components: {
    sidebar,
    GlobalModal
  },
  data() {
    return {
      showPasswordForm: false,
      passwordForm: { newPassword: '', confirmPassword: '' },
      modal: { show: false, type: 'success', title: '', message: '' }
    };
  },
  computed: {
    ...mapState({
      subRetailerSubmitting: (state) =>
        state.retailerController.subRetailerSubmitting,
      showSubRetailerSidebar: (state) =>
        state.retailerController.showSubRetailerSidebar,
      selectedSubRetailer: (state) =>
        state.retailerController.selectedSubRetailer,
    }),
    totalRate() {
      if (this.selectedSubRetailer.transactionType === 'SMART') {
        return 0;
      }
      const agent = Number(this.selectedSubRetailer.agentRate) || 0;
      const dealer = Number(this.selectedSubRetailer.dealerRate) || 0;
      const sureload = Number(this.selectedSubRetailer.sureloadRate) || 0;
      return Math.round((agent + dealer + sureload) * 100) / 100;
    },
    totalRateClass() {
      if (this.totalRate === 100) {
        return 'alert-success';
      } else if (this.totalRate === 0) {
        return 'alert-secondary';
      } else {
        return 'alert-danger';
      }
    }
  },
  methods: {
    ...mapActions({
      getSubRetailers: "retailerController/GetSubRetailers",
      addSubRetailer: "retailerController/AddSubRetailer",
      updateSubRetailer: "retailerController/UpdateSubRetailer",
      changeSubRetailerPassword: "retailerController/ChangeSubRetailerPassword"
    }),
    ...mapMutations({
      setShowSubRetailerSidebar:
        "retailerController/SET_ShowSubRetailerSidebar",
      selectSubRetailer: "retailerController/SELECT_SubRetailer",
    }),
    close() {
      this.selectSubRetailer(null);
      this.setShowSubRetailerSidebar(false);
    },
    async submitSubRetailer() {
      const form = this.$refs.subRetailerForm;
      if (!form.checkValidity()) {
        form.reportValidity(); // Shows the built-in browser messages
        return;
      }

      // Validate total rate for BAYAD and BOTH transaction types
      if (this.selectedSubRetailer.transactionType !== 'SMART' && this.totalRate !== 100) {
        this.showModal('error', 'Validation Error', 'The total of Agent Rate, Dealer Rate, and Sureload Rate must equal exactly 100%');
        return;
      }

      if (this.selectedSubRetailer.subRetailerID != 0) {
        var result = await this.updateSubRetailer().catch((error) => {
          const message = error?.data?.ErrorMessage || 'Unable to update user';
          this.showModal('error', 'Error', message);
        });
        if (result) {
          this.showModal(
            'success',
            `Sub Retailer ${this.selectedSubRetailer.name} successfully updated.`,
          );
          this.close();
          await this.getSubRetailers();
        }
      } else {
        var result = await this.addSubRetailer().catch((error) => {
          const message = error?.data?.ErrorMessage || 'Unable to add user';
          this.showModal('error', 'Error', message);
        });
        if (result) {
          this.showModal('success', `Temporary password: ${result}`, 'Press Confirm after saving the temporary password');
          await this.getSubRetailers();
          this.close();
        }
      }
    },
    async changePassword() {
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        return this.showModal('error', 'Mismatch', 'Passwords do not match.');
      }
      const payload = {
        subRetailerID: this.selectedSubRetailer.subRetailerID,
        newPassword: this.passwordForm.newPassword
      };
      await this.changeSubRetailerPassword(payload)
        .then(() => {
          this.showModal('success', 'Password Changed', 'Password has been updated.');
          this.showPasswordForm = false;
        })
        .catch(err => {
          this.showModal('error', 'Validation Error', err.data?.errors?.join('<br/>') || 'Unable to change password');
        });
    },
    showModal(type, title, message) {
      this.modal = { show: true, type, title, message };
    },
  },
};
</script>

<style scoped>
.alert.alert-success {
  background-color: #d1f4e0 !important;
  border-color: #8ed9ad !important;
  color: #000 !important;
}

.alert.alert-danger {
  background-color: #ffd6db !important;
  border-color: #ffb3bd !important;
  color: #000 !important;
}

.alert.alert-secondary {
  background-color: #dbeafe !important;
  border-color: #93c5fd !important;
  color: #000 !important;
}
</style>
